/* eslint-disable max-len */
import { motion } from 'framer-motion'
import React,{useState} from 'react'
import StatusHandleModal from './StatusHandleModal'

export default function ListUser({list,seteditData,setopen,editData,handleError, handleFetch}) {
    const [OpenPopup, setOpenPopup] = useState(false)
    const [editId, seteditId] = useState('')
    return (
        <div className="">
            <StatusHandleModal 
                handleFetch={handleFetch}
                selectedUser={editData}
                OpenPopup={OpenPopup} 
                setOpenPopup={setOpenPopup} 
                handleError={handleError} />
            <div className="mb-6 mt-9 overflow-auto sidebar" style={{height:'calc(100vh - 240px)'}}>
                <motion.table
                    animate={{ opacity: 1, x: 0 }}
                    initial={{ opacity: 0, x: -10 }}
                    exit={{ opacity: 0, x: -10 }}
                    transition={{ duration: 0.15 }}
                    aria-label="Outside Table" className="w-full table-auto relative">
                    <thead className='sticky top-0 left-0 z-[1]'>
                        <tr className="bg-[#F5F5FA] h-[38px] w-full">
                            <th className="sm:px-6 px-5 py-3 rounded-tl-md rounded-bl-md min-w-[214px]">
                                <span className="flex items-center text-lg text-[#555259] font-bold">First Name
                                </span>
                            </th>
                            <th className="sm:px-6 px-5 py-3 sm:min-w-[212px] min-w-[150px]">
                                <span className="flex items-center text-lg text-[#555259] font-bold">Last Name
                                </span>
                            </th>
                            <th className="sm:px-6 px-5 py-3 min-w-[140px]">
                                <span className="flex items-center text-lg text-[#555259] font-bold">Email Address
                                </span>
                            </th>
                            <th className="sm:px-10 px-5 py-3 min-w-[140px]">
                                <span className="flex items-center text-lg text-[#555259] font-bold">Mobile Number
                                </span>
                            </th>
                            <th className="sm:px-6 px-5 py-3">
                                <span className="flex items-center text-lg text-[#555259] font-bold">Status
                                </span>
                            </th>
                            <th className="sm:px-6 px-5 py-3 rounded-tr-md rounded-br-md">
                                
                            </th>
                        </tr>
                        <tr aria-colspan="7" className="h-4">
                        </tr>
                    </thead>
                    <tbody>
                        {list.map((item, i)=>(
                            <><tr className="bg-[#FFFFFF] rounded-lg">
                                <td className={`sm:px-6 px-5 py-3 text-lg font-normal text-[#${item.user_status==='0'?'808285':'555259'}] border-b border-[#F3F2F5] border-t border-l rounded-tl-lg rounded-bl-lg`}>{item.first_name}</td>
                                <td className={`sm:px-6 px-5 py-3 text-lg font-normal text-[#${item.user_status==='0'?'808285':'555259'}] border-[#F3F2F5] border-t border-b`}>{item.last_name}</td>
                                <td className={`sm:px-6 px-5 py-3 text-lg font-normal text-[#${item.user_status==='0'?'808285':'555259'}] border-[#F3F2F5] border-t border-b`}>{item.email}</td>
                                <td className={`sm:px-6 px-5 py-3 text-lg font-normal text-[#${item.user_status==='0'?'808285':'555259'}] border-[#F3F2F5] border-t border-b`}>{item.phone_number}</td>
                                <td className="sm:px-6 px-5 py-3 border-t border-b">
                                    <div className={`rounded-lg bg-[#${item.user_status=== '1'?'D6FFCA':'D3DBE4'}] h-[30px] w-[88px] flex items-center justify-center`}>
                                        <img src={item.user_status==='1' ? `images/Active-icon.svg`:`/images/inactive-1.svg`} alt="icon" />
                                        <span className={`text-sm font-normal text-[#${item.user_status==='0'?'808285':'555259'}] pl-1 border-[#F3F2F5]`}>{item.user_status==='0'? 'Inactive':'Active'}</span>
                                    </div>
                                </td>
                                <td className="text-lg font-normal text-[#0D1B2A] px-3 py-3 dropstart relative border-[#F3F2F5] border-t border-b border-r rounded-tr-lg rounded-br-lg">
                                    <a href="javascript:void(0)" className="flex justify-center items-center w-fit mx-auto" dropdown-toggle id="actionButton"
                                        data-bs-toggle="dropdown" aria-expanded="false">
                                        <img src="/images/more-vertical.svg" alt="icon" onClick={()=>{
                                            if(item.user_id === editId){
                                                seteditId('')
                                            }else{
                                                seteditId(item.user_id)
                                            }
                                        }}/>
                                    </a>
                                    <ul className={`dropdown-menu border absolute border-[#F0F4F7] ${editId === item.user_id ?'show ':'hidden '} z-[9] bg-[#FFFFFF] w-[140px] left-[-129px] top-0 rounded-lg shadow-sm`} aria-labelledby="actionButton">
                                        <a className="dropdown-item" href="javascript:void(0)" data-bs-toggle="modal" data-bs-target="#editAssistantUser">
                                            <li className="py-2 px-5 text-[#0D1B2A]" onClick={()=>{
                                                seteditData(item);
                                                setopen(true);
                                                seteditId('')
                                            }}>
                                                Edit
                                            </li>
                                        </a>
                                        <a className="dropdown-item" href="javascript:void(0)" 
                                            onClick={()=>{
                                                seteditData(item);
                                                setOpenPopup(true);
                                                seteditId('')
                                            }}
                                            data-bs-toggle="modal" data-bs-target="#deactivateuser">
                                            <li className="pb-1 px-5 text-[#0D1B2A]">
                                                {item.user_status === '0'? 'Activate':'Deactivate'}
                                            </li>
                                        </a>
                                    </ul>
                                </td>
                            </tr><tr aria-colspan="7" className="h-1" />
                            </>

                        ))
                        }
                    </tbody>
                </motion.table>
            </div>
        </div>  
    )
}
